<template>
  <div class="nl-filter-bar">
    <label class="nl-filter-label">Describe your target audience</label>
    <div class="nl-filter-bar-row">
      <input
        v-model="inputText"
        class="form-control nl-filter-input"
        placeholder="e.g. Women 18-30 on WhatsApp in Kenya who completed onboarding but haven't been active in 30 days"
        :disabled="loading"
        @keydown.enter="send" />
      <button type="button" class="btn btn-primary nl-filter-send" :disabled="loading || !inputText.trim()" @click="send">
        <i class="fa fa-spinner fa-spin" v-if="loading"></i>
        <i class="fa fa-magic" v-else></i>
        Generate
      </button>
    </div>
    <div v-if="loading" class="nl-filter-feedback nl-filter-loading">
      <i class="fa fa-spinner fa-spin"></i> Generating filters from your description...
    </div>
    <div v-else-if="lastMessage" class="nl-filter-feedback">
      <i class="fa fa-info-circle"></i> {{ lastMessage }}
    </div>
    <div v-if="!loading && unsupported.length" class="nl-filter-unsupported">
      <div v-for="(note, i) in unsupported" :key="i"><i class="fa fa-exclamation-triangle"></i> {{ note }}</div>
    </div>
  </div>
</template>

<script>
import apiold from '../../../../utils/api'

export default {
  name: 'NlFilterBar',
  props: {
    currentFilters: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      inputText: '',
      loading: false,
      lastMessage: '',
      unsupported: [],
      history: []
    }
  },
  methods: {
    async send () {
      const text = this.inputText.trim()
      if (!text || this.loading) return
      this.loading = true
      // Turn on the parent's full-page loader for the whole AI pass. On the success path the parent
      // keeps it up while applyAiFilters fetches options + the count, and clears it itself; here we
      // only clear it (generating-abort) when there's nothing for the parent to process.
      this.unsupported = []
      this.$emit('generating-start')
      const priorHistory = this.history.slice()
      this.history.push({ role: 'user', text })
      let failed = false
      // Local calendar date (never toISOString, it shifts the day in IST) so relative phrases resolve correctly.
      const now = new Date()
      const pad = n => String(n).padStart(2, '0')
      const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
      try {
        const response = await apiold.buildRequest('audience-builder-chat', 'POST', {
          message: text,
          history: priorHistory,
          currentFilters: this.currentFilters,
          today
        })
        const { message, filters, unsupported } = response.data
        this.unsupported = Array.isArray(unsupported) ? unsupported : []
        this.lastMessage = message || ''
        this.history.push({ role: 'system', text: this.lastMessage + (this.unsupported.length ? ` (Could not apply: ${this.unsupported.join(' ')})` : '') })
        if (filters) {
          this.$emit('filters-received', filters)
        } else {
          this.$emit('generating-abort')
        }
      } catch (err) {
        failed = true
        this.lastMessage = 'Something went wrong while generating filters. Please try again.'
        // Drop the unanswered turn so the next request doesn't send two user turns in a row.
        this.history = priorHistory
        this.$emit('generating-abort')
      } finally {
        this.loading = false
        // Keep what the user typed if the request failed, so they can just retry.
        if (!failed) this.inputText = ''
      }
    }
  }
}
</script>

<style scoped>
.nl-filter-bar {
  margin-bottom: 16px;
  padding: 14px 18px;
  background: linear-gradient(135deg, #E6F5F4, #e3f2fd);
  border: 1.5px solid #0D9488;
  border-radius: 8px;
}
.nl-filter-label {
  font-size: 11px;
  font-weight: 700;
  color: #0B7C72;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 8px;
  display: block;
}
.nl-filter-bar-row {
  display: flex;
  gap: 10px;
}
.nl-filter-input {
  flex: 1;
}
.nl-filter-send {
  white-space: nowrap;
}
.nl-filter-feedback {
  margin-top: 10px;
  font-size: 13px;
  color: #31708f;
}
.nl-filter-unsupported {
  margin-top: 6px;
  font-size: 12px;
  color: #c53030;
  background: #fff5f5;
  border: 1px solid #feb2b2;
  border-radius: 6px;
  padding: 6px 10px;
}
.nl-filter-loading {
  color: #0D9488;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// NlFilterBar.vue?4b3a11ac